import React from "react";
import ReactDOM from "react-dom";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, } from "@material-ui/core";
import { useUpdateUser } from "frontend/src/domain/user/actions";
var FormDialog = function (_a) {
    var isOpen = _a.isOpen, userId = _a.userId, onClose = _a.onClose;
    var _b = React.useState(""), password = _b[0], setPassword = _b[1];
    var _c = React.useState(null), error = _c[0], setError = _c[1];
    var onPasswordChange = function (evt) {
        return setPassword(evt.target.value);
    };
    var _d = useUpdateUser(), update = _d.mutate, isSuccess = _d.isSuccess;
    var submit = function (evt) {
        evt.preventDefault();
        if (password.length >= 8) {
            setError(null);
            update({ id: userId, password: password });
        }
        else {
            setError("Минимальная длинна пароля - 8 символов.");
        }
    };
    React.useEffect(function () {
        if (isSuccess) {
            setPassword("");
            onClose();
        }
    }, [isSuccess]);
    return (React.createElement(Dialog, { open: isOpen, onClose: onClose, fullWidth: true, maxWidth: "sm" },
        React.createElement("form", { onSubmit: submit },
            React.createElement(DialogTitle, null, "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C"),
            React.createElement(DialogContent, null,
                React.createElement(TextField, { label: "Новый пароль", fullWidth: true, type: "text", value: password, onChange: onPasswordChange, error: Boolean(error), helperText: error })),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: onClose, color: "primary" }, "\u041E\u0442\u043C\u0435\u043D\u0430"),
                React.createElement(Button, { color: "primary", type: "submit" }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")))));
};
export var EditClientPassword = function (_a) {
    var userId = _a.userId;
    var _b = React.useState(false), isOpen = _b[0], setOpen = _b[1];
    var open = function () { return setOpen(true); };
    var close = function () { return setOpen(false); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { color: "primary", variant: "outlined", onClick: open }, "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C"),
        ReactDOM.createPortal(React.createElement(FormDialog, { isOpen: isOpen, onClose: close, userId: userId }), document.body)));
};
